import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBIcon,
  MDBBtnGroup,
  MDBBtn,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";

export class CategoryBreakdownTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "expenses", // "expenses" o "incomes"
    };
  }

  formatCurrency(value) {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(value ?? 0);
  }

  render() {
    const { expensesTop = [], incomesTop = [], title = "Top categorías", emptyText } = this.props;
    const { activeTab } = this.state;

    const data = activeTab === "expenses" ? expensesTop : incomesTop;
    const defaultEmpty = `No hay ${activeTab === "expenses" ? "gastos" : "ingresos"} en el período.`;

    return (
      <MDBCard>
        <MDBCardBody>
          <MDBCardTitle className="dashboard-section-title">
            <MDBIcon fas icon="list" className="me-2" />
            {title}
          </MDBCardTitle>

          {/* Tab buttons */}
          <div className="mb-3">
            <MDBBtnGroup size="sm" role="group">
              <MDBBtn
                color={activeTab === "expenses" ? "danger" : "light"}
                active={activeTab === "expenses"}
                onClick={() => this.setState({ activeTab: "expenses" })}
              >
                <MDBIcon fas icon="arrow-down" className="me-1" />
                Gastos
              </MDBBtn>
              <MDBBtn
                color={activeTab === "incomes" ? "success" : "light"}
                active={activeTab === "incomes"}
                onClick={() => this.setState({ activeTab: "incomes" })}
              >
                <MDBIcon fas icon="arrow-up" className="me-1" />
                Ingresos
              </MDBBtn>
            </MDBBtnGroup>
          </div>

          {/* Data table */}
          {data && data.length > 0 ? (
            <MDBTable hover className="mb-0">
              <MDBTableHead>
                <tr>
                  <th className="text-muted small" style={{ width: "70%" }}>
                    Categoría
                  </th>
                  <th className="text-muted small text-end" style={{ width: "30%" }}>
                    Importe
                  </th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {data.map((item, idx) => (
                  <tr key={idx}>
                    <td className="py-2">
                      <small>{item.categoria}</small>
                    </td>
                    <td className="text-end py-2">
                      <strong style={{ color: activeTab === "expenses" ? "#c62828" : "#00796b" }}>
                        {this.formatCurrency(item.total)}
                      </strong>
                    </td>
                  </tr>
                ))}
              </MDBTableBody>
            </MDBTable>
          ) : (
            <p className="text-muted text-center py-3 small mb-0">
              {emptyText ?? defaultEmpty}
            </p>
          )}
        </MDBCardBody>
      </MDBCard>
    );
  }
}
